import { render, staticRenderFns } from "./fixedBotton.vue?vue&type=template&id=0e143224&scoped=true"
import script from "./fixedBotton.vue?vue&type=script&lang=js"
export * from "./fixedBotton.vue?vue&type=script&lang=js"
import style0 from "./fixedBotton.vue?vue&type=style&index=0&id=0e143224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e143224",
  null
  
)

export default component.exports